import '@/assets/scss/index.scss'

import TitleCmp from '@/components/pub/TitleCmp.vue' // 타이틀
import TabCmp from '@/components/ms/TabCmp.vue' // 탭
import KakaoMap from '@/components/common/KakaoMap.vue'
import InfiniteScroll from '@/components/common/scroll/InfiniteScroll.vue'
import NoData from '~/components/common/template/NoData.vue'

import json from '~/scriptData/ms/cmn/json/CMN_MS_json.js'

import { commonfunc } from '~/mixin/common'
import { cmnMsStr } from '~/mixin/ms/msMixin'
import { homepageTag } from '~/utils/criteo'

/**
 * packageName    : ms.msg
 * fileName       : SCR_MSG_0019
 * author         :
 * date           : 2023-09-14
 * description    : 매장 위치 찾기
 * =============================================================
 * DATE             AUTHOR          NOTE
 * -------------------------------------------------------------
 * 2023-09-14       fekimsh         최초생성
 */
export default {
  name: 'SCR_MSG_0019',
  components: {
    NoData,
    TitleCmp,
    TabCmp,
    KakaoMap,
    InfiniteScroll
  },
  mixins: [commonfunc, cmnMsStr],
  layout: 'DsMainLayout',

  head () {
    return {
      title: '매장 위치 찾기 : 다이소몰',
      meta: [
        { hid: 'description', name: 'description', content: '일상이 다이소가 되다. 온라인 국민가게, 다이소' },
        { hid: 'og:title', property: 'og:title', content: '매장재고 위치찾기 : 다이소몰' },
        { hid: 'og:url', property: 'og:url', content: window.location.href },
        { hid: 'og:type', property: 'og:type', content: 'website' },
        { hid: 'og:site_name', property: 'og:site_name', content: '다이소몰' },
        { hid: 'og:description', property: 'og:description', content: '일상이 다이소가 되다. 온라인 국민가게, 다이소' }
      ],
    }
  },

  data () {
    return {
      breadcrumbs: [
        {
          url: process.env.WEB_BASE_URL + '/ms/msg/SCR_MSG_0019',
          text: '매장위치찾기',
        },
      ],
      titleData: {
        title: '매장 위치 찾기',
        crumbs: []
      },
      active: '2', // 탭 index(활성화)
      tabsData: json.msTabsData,

      labelPosition_left: 'left',

      srchForm: {
        mbMngNo: this.$store.getters['session/getMbMngNo'],
        keyword: '',
        srchBassPkupStrYn: 'Y',

        geolocationAgrYn: 'N',
        curLttd: 0.0,
        curLitd: 0.0,

        currentPage: 1,
        pageSize: 10

      },

      strList: null,
      totalCnt: 0,
      login: !this.isEmpty(this.$store.getters['session/getMbMngNo']),

      // 무한 스크롤
      bSrchKeyword: false,
      bLoadMore: false,
      bSrching: false,

      // 카카오맵 다시 그리기용
      startIndex: 0,
      reloadSize: 0,

    }
  },
  jsonld () {
    const items = this.breadcrumbs.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      item: {
        '@id': item.url,
        name: item.text,
      },
    }))
    return {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: items,
    }
  },
  async mounted () {
    if (this.login) {
      await this.selGeolocation()
    } else {
      this.getGeolocation(this.geoData)
    }

    homepageTag('')
    this.callAirBridgeForProductListView('msg', '매장 위치 찾기')
  },

  computed: {
    loadMoreDisabled () {
      return this.bLoadMore || !this.bSrchKeyword || (this.totalCnt <= this.strList.length)
    },

  },
  watch: {
    'strList' () {
      if (this.strList && this.strList.length > 0) {
        // this.reload(this.startIndex, this.reloadSize)
        this.reloadAll()
      }
    },

    'geoData.flag' (val) {
      this.srchForm.geolocationAgrYn = this.geoData.geolocationAgrYn
      this.srchForm.curLttd = this.geoData.strLttd
      this.srchForm.curLitd = this.geoData.strLitd

      this.selStr('N', false)
    }
  },
  methods: {

    async selStr (srchYn, add) {
      this.srchForm.srchYn = srchYn

      if (srchYn === 'Y' && !this.srchForm.keyword) {
        this.$alert('매장명 또는 지역을 입력해주세요.')
        return
      }

      if (srchYn === 'Y' && this.srchForm.keyword.length < 2) {
        this.$alert('검색어는 2글자 이상 입력해주세요.')
        return
      }

      this.bSrchKeyword = srchYn === 'Y'
      this.bSrching = true

      if (!add) {
        this.strList = []
        this.totalCnt = 0
        this.srchForm.currentPage = 1
        this.srchForm.pageSize = 10
        this.startIndex = 0
        this.reloadSize = 0
      }

      // 조회
      await this.$AxiosBuilder
        .data(this.srchForm)
        .build()
        .post('/ms/msg/selStr')
        .then((res) => {
          if (!this.isEmpty(res.data.data)) {
            this.startIndex = this.strList.length
            this.reloadSize = res.data.data.length
            this.totalCnt = res.data.data.length ? res.data.data[0].totalCnt : 0

            if (add) {
              this.strList = this.strList.concat(res.data.data)
            } else {
              this.strList = res.data.data
            }

            this.bLoadMore = false
            this.bSrching = false

            // this.reload(this.startIndex, this.reloadSize)
            this.reloadAll()
          }
        })
    },
    // kakaoMap 컴포넌트 생성
    reload (startIndex, size) {
      for (let i = startIndex; i < (startIndex + size); i++) {
        setTimeout(() => {
          this.$refs['kakaoMap' + i][0].create()
        }, 1000)
      }
    },
    reloadAll () {
      this.strList.forEach((item, idx) => {
        setTimeout(() => {
          this.$refs['kakaoMap' + idx][0].create()
        }, 1000)
      })
    },
    handleKeyEnter () {
      this.$refs.auto.close()
      this.$refs.srchBtn.$el.focus()
      this.$refs.srchBtn.$el.click()
    },

    loadMore () {
      if (this.loadMoreDisabled) {
        return
      }

      this.bLoadMore = true
      this.srchForm.currentPage++
      this.selStr('Y', true)
    },
    callAirBridgeForProductListView (categoryName, categoryNameDetail) {
      const productListInfo = new this.$airbridge.ProductListObject(categoryName, categoryNameDetail)
      this.$airbridge.viewProductList(productListInfo)
    },
  }
}
